import _ from 'lodash';
import {
  call,
  put,
  select,
  fork,
  takeLatest
} from 'redux-saga/effects';
import {
  LOAD_CONTENT
} from './account';
import { browserHistory } from 'react-router';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  showGlobalSpinner,
  hideGlobalSpinner,
  errorPageByFlow
} from '../../../common/common';

// WATCHERS
export function* loadRedirectWatch() {
  yield takeLatest(LOAD_CONTENT, loadRedirectWorker);
}

// WORKERS
export function* loadRedirectWorker() {
  try {
    yield put(showGlobalSpinner({hideContent: true}));

    const errorPage = yield select(errorPageByFlow);
    const success = yield call(dataProvider.load, [
      {state: 'accountMultipleAddress'}
    ], {errorPage});

    if (!success) {
      return;
    }

    const state = yield select();
    const queryString = _.get(state, 'routing.locationBeforeTransitions.search');

    browserHistory.push(`${navigationRoutes[navigationSteps.account.MULTIPLE_ADDRESS].path}${queryString}`);

    yield put(hideGlobalSpinner());
  } catch(e) {
    //console.log(e);
  }
}

export default function* accountSagas() {
  yield [
    fork(loadRedirectWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Account/account/accountSagas.js
 **/